import { defineVariants } from "@/runtime/style-engine/define-variants";

export const textareaClasses = defineVariants({
  base: `
    inline-flex! flex-row! items-center! gap-2!
    min-w-0
    cursor-text
    outline-none
    transition-colors
  `,
  input: `
    flex-1
    w-full
    min-w-0
    bg-transparent
    border-none
    outline-none
    text-inherit
    font-inherit
    cursor-inherit
    [:where([data-disabled="true"])_&]:cursor-not-allowed
  `,

  variants: {
    variant: {
      solid: `hover:bg-(--card-color)/75`,
      outline: `hover:bg-(--card-color)/5`,
      soft: `hover:bg-(--card-color)/15`,
      subtle: `hover:bg-(--card-color)/25`,
      ghost: `hover:bg-(--card-color)/5`,
    },

    size: {
      xs: `px-2! py-1! text-xs rounded!`,
      sm: `px-2.5! py-1.5! text-sm rounded-md!`,
      md: `px-3! py-2! text-base rounded-lg!`,
      lg: `px-4! py-2.5! text-lg rounded-lg!`,
      xl: `px-5! py-3! text-xl rounded-lg!`,
    },

    disabled: {
      true: `opacity-50 cursor-not-allowed!`,
      false: `focus-within:ring-2 focus-within:ring-(--color-foreground)`,
    },

    block: {
      true: `w-full!`,
      false: `w-auto!`,
    },
  },

  defaults: {
    variant: "subtle",
    size: "md",
    disabled: false,
    block: false,
  },
});
